import misRutas from 'vue-routes-generator'
import MisContratosMainComponent from './App'
import ListadoContratosComponent from './components/listado/index'
import EditorContratosComponent from './components/contrato/index'
import VisorContratosComponent from './components/visor-contrato/visor-contrato'
import StoreContratos from './store'
import Store from '../../core/vue/store/stores'

export default {
	install: Vue => {
		Store.registerModule('mis-contratos', StoreContratos)
		misRutas.route('/main').child('contratos', {
			name: 'Contratos',
			component: MisContratosMainComponent
		})

		misRutas.route('/main').child('contratos').child('listado', {
			name: 'Listado de contratos',
			component: ListadoContratosComponent
		})

		misRutas.route('/main').child('contratos').child('listado/:id', {
			name: 'Detalle del contrato',
			component: ListadoContratosComponent
		})

		misRutas.route('/main').child('contratos').child('editar', {
			name: 'Editor de contratos',
			component: EditorContratosComponent
		})

		misRutas.route('/main').child('contratos').child('ver', {
			name: 'Visor de contratos',
			component: VisorContratosComponent
		})

		misRutas.route('/main').child('contratos').child('ver').child(':id', {
			name: 'Visor de contratos',
			component: VisorContratosComponent
		})

		misRutas.route('/main').child('contratos').child('editar').child(':id', {
			name: 'Editor de contratos',
			component: EditorContratosComponent
		})

		misRutas.route('/main').child('contratos').child('editar').child(':id', {
			name: 'Editor de contratos',
			component: EditorContratosComponent
		})

		misRutas.route('/main').child('contratos').child('editar').child(':id').child(':vista', {
			name: 'Editor de contratos (detalles)',
			component: EditorContratosComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/mis-contratos/vue/index.js